import { injectable, inject } from "@launchtray/tsyringe-async";
import { IShopController } from "./IShopController";
import { PaymentResult } from "../../../../../web3/PaymentResult";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { IContextResolver } from "../../../../composition/IContextResolver";
import { MyWalletModule } from "../../myWallet/MyWalletModule";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";
import { SceneManager } from "../../../../../scene/SceneManager";
import { ILogger } from "../../../../logger/ILogger";
import { WalletTabType } from "../../myWallet/components/WalletTabType";
import { EthL1PaymentProcessingModule } from "../../ethL1paymentprocessing/EthL1PaymentProcessingModule";
import { PaymentProcessingType } from "../../ethL1paymentprocessing/type/PaymentProcessingType";
import { EthL1PaymentProcessingPopupSceneOptions } from "../../ethL1paymentprocessing/scenes/EthL1PaymentProcessingPopupSceneOptions";
import { Erc20PaymentProcessingModule } from "../../ethL1paymentprocessing/Erc20PaymentProcessingModule";
import { PaymentProcessingPopupSceneOptions } from "../../ethL1paymentprocessing/scenes/PaymentProcessingPopupSceneOptions";
import { Web3Config } from "by/gamefactory/web3/config/Web3Config";

@injectable()
export class ShopController implements IShopController {
    private readonly web3Model: Web3Model;
    private readonly web3Config: Web3Config;
    private readonly sceneManager: SceneManager;
    private readonly contextResolver: IContextResolver;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly logger: ILogger;

    public constructor(
        web3Model: Web3Model,
        web3Config: Web3Config,
        sceneManager: SceneManager,
        asyncOperationNotification: AsyncOperationNotification,
        @inject("IContextResolver") contextResolver: IContextResolver,
        @inject("ILogger") logger: ILogger
    ) {
        this.web3Model = web3Model;
        this.web3Config = web3Config;
        this.sceneManager = sceneManager;
        this.contextResolver = contextResolver;
        this.asyncOperationNotification = asyncOperationNotification;
        this.logger = logger;
    }

    public async showPaymentPopup(tokenId: string, price: number): Promise<PaymentResult> {
        try {
            this.asyncOperationNotification.show();
            const baseErc20PaymentProcessingModule = await this.contextResolver.resolve(Erc20PaymentProcessingModule);
            const tokenSymbol = await this.web3Model.getTokenSymbol(this.web3Config.targetChain, this.web3Config.reservoirDevUsdcCurrency);
            this.asyncOperationNotification.hide();
            return await baseErc20PaymentProcessingModule.start({
                chain: this.web3Config.targetChain,
                erc20Address: this.web3Config.reservoirDevUsdcCurrency,
                tokenSymbol, 
                type: PaymentProcessingType.STORE_PACKAGE,
                price,
                tokenId
            } as PaymentProcessingPopupSceneOptions<PaymentProcessingType.STORE_PACKAGE>);
        }
        catch(e: unknown) {
            this.logger.error("Exception processing usdc payment popup in shop: ", e);
            return PaymentResult.FAILURE;
        }
        finally {
            this.asyncOperationNotification.hide();
        }
    }

    public async showMyWalletPopup(): Promise<void> {
        const myWalletModule = await this.asyncOperationNotification.autoShowHide(this.contextResolver.resolve(MyWalletModule));
        await myWalletModule.start(WalletTabType.DICE_ROLLS);
    }

    public async showMonPaymentProcessingPopup(price: number, tokenId: string): Promise<PaymentResult> {
        const monPaymentProcessingModule = await this.asyncOperationNotification.autoShowHide(this.contextResolver.resolve(EthL1PaymentProcessingModule));
        return await monPaymentProcessingModule.start({
            type: PaymentProcessingType.STORE_PACKAGE,
            price,
            tokenId
        } as EthL1PaymentProcessingPopupSceneOptions<PaymentProcessingType.STORE_PACKAGE>);
    }
}
